import React from "react";

import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { IntroductionPopoverProps } from "./introductionPopover.model";
import "@companion-core/web/src/Assets/Styles/scss/bell.scss";
import { useTranslation } from "react-i18next";

export const IntroductionPopover = ({ onClose }: IntroductionPopoverProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="bell-intro-popover__title">
        <span className="body-text-5 bell-intro-popover__title-text">
          {t("common.bell.introduction.title")}
        </span>
        <div onClick={onClose} className="bell-intro-popover__title-close">
          <FontIcon name="JP-Close-bold" size={20} />
        </div>
      </div>
      <div className="body-text-8">{t("common.bell.introduction.text")}</div>
    </>
  );
};
